import React from "react";

import {DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../helper";
import {getWorkflowLabel} from "../../../dashboard-cell/WorkflowRibbon";
import {
  AdmissionFromSearch,
  downloadAdmissionPdf,
} from "../../../../services/AdmissionsService";
import {useDownloadManager} from "../../../../hooks/useDownloadManager";

export const DownloadPDFDropdownItem = ({
  admission,
  label,
  ...props
}: {
  admission: AdmissionFromSearch;
  label?: string;
}) => {
  const {start} = useDownloadManager();
  const resolvedLabel =
    label ??
    `Download ${getWorkflowLabel(admission.workflowType) || "Admission"}`;

  return (
    <DropdownMenuItem
      pointer
      onClick={() => {
        start(resolvedLabel, () =>
          downloadAdmissionPdf({
            admissionId: admission.id,
            type: "full",
            status: admission.status,
          }),
        );
      }}
      testId={getResidentTestId(admission, "downloadPdf")}
      {...props}
    >
      {resolvedLabel}
    </DropdownMenuItem>
  );
};
